import MapWithSearch, {
  MapWithSearchProps,
} from '../MapWithSearch/MapWithSearch';

export type HomeProps = MapWithSearchProps;

const Home = (props: HomeProps) => {
  return <MapWithSearch {...props} route="/" />;
};

export default Home;
